import React, { useEffect, useContext, useState, useCallback } from "react";
import { useParams, useHistory } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

import lifeAreasData from "../../../resources/lifeAreas";
import { setDataInLocalStorage } from "../../../utils/storage";
import { colourThemes } from "../../../styles/colourPalettes";

import ColourContext from "../../../contexts/ColourContext";
import LifeAreasContext from "../../../contexts/LifeAreasContext";

import Container from "../../../hoc/container/Container";

import closeIcon from "../../../assets/icons/close.svg";
import backIcon from "../../../assets/icons/arrow-left.svg";

import style from "./System.module.css";
import useLifeAreaTitle from "../../../hooks/returnLifeAreaTitle";
import returnLifeAreaTitle from "../../../hooks/returnLifeAreaTitle";
import blocksData, { BlockData } from "../../../resources/blocks";

// type SystemProps = {};

const System = () => {
  // Colour Theme
  const { key: colourKey } = useContext(ColourContext);
  const colour = colourThemes[colourKey];
  // Area
  const history = useHistory();
  const { areaKey } = useParams();
  const areaTitle = returnLifeAreaTitle(areaKey);

  const { lifeAreas, dispatchLifeAreas } = useContext(LifeAreasContext);

  const gotBackToArea = useCallback(() => {
    const areaUrl = `/personal/${areaKey}`;
    history.push(areaUrl);
  }, [history, areaKey]);

  const handleAddBlockToSystemPressed = useCallback(
    (blockId: string) => {
      dispatchLifeAreas({
        type: "ADD_BLOCK_TO_AREA",
        payload: { areaKey: areaKey, blockId: blockId },
      });
      gotBackToArea();
    },
    [gotBackToArea, dispatchLifeAreas, areaKey]
  );

  return (
    <motion.section
      key="system"
      className={style.container}
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      exit={{ y: "100%" }}
      transition={{ ease: "easeIn" }}
    >
      <header>
        <h3>{areaTitle} System</h3>
        <img
          src={closeIcon}
          role="button"
          alt="Back to Area"
          onClick={gotBackToArea}
        />
      </header>
      <Container containerClass={style.blocksContainer}>
        {Object.keys(blocksData).map((blockId: string) => (
          <div
            key={blockId}
            onClick={() => handleAddBlockToSystemPressed(blockId)}
          >
            {blocksData[blockId].title}
          </div>
        ))}
      </Container>
    </motion.section>
  );
};

export default System;
